import * as Sentry from "@sentry/react";

const alreadyReported = new Set<string>();

const fingerprintOf = (error: unknown): string => {
  if (error instanceof Error) {
    return `${error.name}:${error.message}`;
  }
  try {
    return String(error);
  } catch {
    return "unstringifiable";
  }
};

// Un quota sature ou une base fermee font echouer *chaque* ecriture qui suit : sans dedoublonnage
// une seule session remplit Sentry. On garde la premiere de chaque cause, avec l'occupation du
// stockage — le seul chiffre qui distingue « disque plein » de « base cassee ».
export const reportStorageWriteFailure = async (error: unknown): Promise<void> => {
  const fingerprint = fingerprintOf(error);

  if (alreadyReported.has(fingerprint)) {
    return;
  }
  alreadyReported.add(fingerprint);

  const estimate = await navigator.storage?.estimate?.().catch(() => undefined);

  Sentry.captureException(error, {
    extra: { storageQuota: estimate?.quota, storageUsage: estimate?.usage },
    tags: { failure: "indexeddb-write" },
  });
};
